import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import HomeBannerData from "../../components/admincomponents/HomeBannerData";
import FacadePageManage from "../../components/admincomponents/FacadePageManage";

function FacadePageBannerData({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <FacadePageManage />            
    </>
  );
}

export default FacadePageBannerData;
